import React, { useState } from "react";

/**
 * GeocodeComponent
 * Props:
 * - apiKey: Google Maps Geocoding API key (optional, will use REACT_APP_GOOGLE_MAPS_API_KEY by default)
 * - onResult: function({ lat, lng, address, raw }) called with geocode result
 *
 * Usage:
 * <GeocodeComponent onResult={result => ...} />
 */
function GeocodeComponent({ apiKey, onResult }) {
  const [address, setAddress] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleGeocode = async (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent event from bubbling to parent forms
    setLoading(true);
    setError("");
    setResult(null);
    try {
      const key = apiKey || process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
      const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${key}`;
      const res = await fetch(url);
      const data = await res.json();
      if (data.status === "OK" && data.results.length > 0) {
        const loc = data.results[0].geometry.location;
        setResult({ lat: loc.lat, lng: loc.lng, address: data.results[0].formatted_address, raw: data.results[0] });
        if (onResult) onResult({ lat: loc.lat, lng: loc.lng, address: data.results[0].formatted_address, raw: data.results[0] });
      } else {
        setError("No results found.");
      }
    } catch (err) {
      setError("Geocoding failed.");
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 400, margin: "0 auto", padding: 16 }}>
      <form onSubmit={handleGeocode} style={{ display: "flex", gap: 8 }}>
        <input
          type="text"
          value={address}
          onChange={e => setAddress(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.stopPropagation(); // Prevent Enter from bubbling to parent forms
            }
          }}
          placeholder="Enter address to geocode"
          style={{ flex: 1, padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
        />
        <button type="submit" disabled={loading} style={{ padding: "8px 16px", borderRadius: 4, background: "#d50032", color: "#fff", border: "none", fontWeight: 600 }}>
          {loading ? "Geocoding..." : "Geocode"}
        </button>
      </form>
      {error && <div style={{ color: "#d50032", marginTop: 8 }}>{error}</div>}
      {result && (
        <div style={{ marginTop: 12, fontSize: 15 }}>
          <div><b>Address:</b> {result.address}</div>
          <div><b>Lat:</b> {result.lat}</div>
          <div><b>Lng:</b> {result.lng}</div>
        </div>
      )}
    </div>
  );
}

export default GeocodeComponent;
